export const FEEDS_SET_SOCKET_SESSION = 'FEEDS_SET_SOCKET_SESSION';
export const FEEDS_SET_FEEDS = 'FEEDS_SET_FEEDS';
export const FEEDS_GET_FEEDS_BEGIN = 'FEEDS_GET_FEEDS_BEGIN';
export const FEEDS_GET_FEEDS_SUCCESS = 'FEEDS_GET_FEEDS_SUCCESS';
export const FEEDS_GET_FEEDS_FAILURE = 'FEEDS_GET_FEEDS_FAILURE';
export const FEEDS_GET_FEEDS_DISMISS_ERROR = 'FEEDS_GET_FEEDS_DISMISS_ERROR';
export const FEEDS_ADD_FEED = 'FEEDS_ADD_FEED';
export const FEEDS_UNSET_FEEDS = 'FEEDS_UNSET_FEEDS';
export const FEEDS_GET_ACTIVITY_BEGIN = 'FEEDS_GET_ACTIVITY_BEGIN';
export const FEEDS_GET_ACTIVITY_SUCCESS = 'FEEDS_GET_ACTIVITY_SUCCESS';
export const FEEDS_GET_ACTIVITY_FAILURE = 'FEEDS_GET_ACTIVITY_FAILURE';
export const FEEDS_GET_ACTIVITY_DISMISS_ERROR = 'FEEDS_GET_ACTIVITY_DISMISS_ERROR';
export const FEEDS_GET_PUBLIC_FEEDS_BEGIN = 'FEEDS_GET_PUBLIC_FEEDS_BEGIN';
export const FEEDS_GET_PUBLIC_FEEDS_SUCCESS = 'FEEDS_GET_PUBLIC_FEEDS_SUCCESS';
export const FEEDS_GET_PUBLIC_FEEDS_FAILURE = 'FEEDS_GET_PUBLIC_FEEDS_FAILURE';
export const FEEDS_GET_PUBLIC_FEEDS_DISMISS_ERROR = 'FEEDS_GET_PUBLIC_FEEDS_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/feeds/redux/constants.js